import { render, staticRenderFns } from "./AssociationIcon.vue?vue&type=template&id=5254b7fb&"
import script from "./AssociationIcon.vue?vue&type=script&lang=js&"
export * from "./AssociationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports